import Navbar from "../components/Navbar";
import About from "../components/About";
import Contact from "../components/Contact";
import Projects from "../components/Projects";
import Services from "../components/Services";
import Showcase from "../components/Showcase";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Showcase />
      <About />
      <Services />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
